const initialState = {
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_COMPANIES":
      return Object.assign({}, state, {
        [action.propertyName]: action.value,
      });
    case "SET_MULTIPLE_STATE_COMPANIES":
      return Object.assign({}, state, action.newObject);
    default:
      return state;
  }
}

// set state dashboard
export function setStateCompanies(propertyName, value) {
  return {
    type: "SET_STATE_COMPANIES",
    propertyName,
    value,
  };
}

// set multi dashboard
export function setMultipleStateCompanies(newObject) {
  return {
    type: "SET_MULTIPLE_STATE_COMPANIES",
    newObject,
  };
}
